module.exports = __webpack_public_path__ + "img/enigma-4.4c7d8367.png";